/**
 * One date format for every invoice surface: `MM/DD/YYYY`, zero-padded.
 *
 * The billing screens used to mix three forms — `3/10/2026` from the shared
 * `formatDate()`, `Apr 9, 2026` from the due cell, and the picker's own — so a
 * single row could print the same kind of fact three different ways. Figures
 * also line up in a column of them, which a short month name does not.
 *
 * Deliberately scoped to billing rather than changing the app-wide
 * `formatDate()`: jobs, timesheets and files keep the locale short form.
 *
 * A date-only `YYYY-MM-DD` is anchored at LOCAL midnight, not parsed as UTC —
 * `new Date('2026-01-05')` is UTC midnight, which reads as the 4th anywhere west
 * of Greenwich, and that is the bug `formatDate()` carries the same guard for. A
 * timestamp is shown in the reader's own zone, which is the right thing to do
 * with a real instant.
 */
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

export function formatBillingDate(value: string): string {
  const date = DATE_ONLY.test(value) ? new Date(`${value}T00:00:00`) : new Date(value);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}
